import React from 'react';
import { string, bool } from 'prop-types';
import ErrorIcon from 'Modules/ErrorIcon';
import Space from 'Modules/Space/Space';

const ErrorText = ({ text, showIcon }) => (
  <div
    className="error flex flex-row align-items-center gap-1 justify-end"
    style={{ fontSize: 13, width: '100%', color: '#ea4343' }}>
    <Space direction="horizontal" size={4} width="100%" justify="end">
      {showIcon && <ErrorIcon />}
      <span>{text}</span>
    </Space>
  </div>
);

ErrorText.propTypes = {
  text: string,
  showIcon: bool,
};
ErrorText.defaultProps = {
  text: '',
  showIcon: true,
};

export default ErrorText;
